// Single esbuild entrypoint. Replaces both the Sprockets manifest
// (app/assets/javascripts/application.js) and the Webpacker pack
// (app/javascript/packs/application.js).
import Rails from '@rails/ujs'
import './jquery_global'
import 'bootstrap'
import './mount'
import './theme'
import { fastMode } from './timing'

// Per-page jQuery behaviours. These used to be picked up implicitly by the
// Sprockets manifest's `//= require_tree .`; esbuild has no equivalent, so they
// are imported explicitly. Each one self-gates on the html class that
// layouts/application.html.haml sets, so importing them all is safe.
import './views/articles/new_from_rss'
import './views/articles/new_from_url'
import './views/library_texts/index'

// Powers `link_to ..., method: :delete` and `confirm:` in the views.
// Rails 8 assumes Turbo instead; we keep UJS so those 16 call sites are unchanged.
Rails.start()

// Under test, make every jQuery animation resolve instantly. Callbacks still
// fire, so nothing that waits on an animation's completion breaks — it just stops
// costing wall clock. Paired with the CSS duration overrides in the layout.
if (fastMode) {
  $.fx.off = true
}

$(function () {
  // always pass csrf tokens on ajax calls
  $.ajaxSetup({
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  })

  $('body').popover({ selector: '[data-toggle="popover"]' })
})
